import { useContext, useEffect } from 'react';
import MenuContext from 'shared/components/AppRouter/context/MenuContext'
import filterPages from 'shared/utils/filterPages'
import Store from 'redux/Store'

interface useInitProps {
    setPages: Function
    position?: String | boolean | undefined
}

const useInit = (props: useInitProps) => {
    
    const pages = useContext(MenuContext)
    let filteredPages;
    let menuPages = Store.getState().menuPages
    
    if (typeof props.position === 'string') {
        filteredPages = filterPages(pages, props.position)
    }
    else {
        filteredPages = []
    }
    
    useEffect(() => {
        props.setPages(filteredPages)
    }, [menuPages])
}

export default useInit